"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fbxToImg = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
var sceneUtils_1 = require("./sceneUtils");
var camera_utils_1 = require("./camera-utils");
/**
 * Converts an fbx url to an img (returned as a dataurl)
 */
function fbxToImg(fbxUrl_1) {
    return __awaiter(this, arguments, void 0, function (fbxUrl, _a) {
        var manager, loader, fbxObject, scene, camera, _b, cameraPosition, cameraLookPosition, directionalLight, light;
        var _c = _a === void 0 ? {} : _a, _d = _c.imgWidth, imgWidth = _d === void 0 ? 250 : _d, _e = _c.imgHeight, imgHeight = _e === void 0 ? 250 : _e, _f = _c.fov, fov = _f === void 0 ? 45 : _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    manager = new realms_three_1.default.LoadingManager();
                    manager.addHandler(/\.tga$/i, new realms_three_1.default.STDLIB.TGALoader(manager));
                    loader = new realms_three_1.default.STDLIB.FBXLoader(manager);
                    return [4 /*yield*/, loader.loadAsync(fbxUrl)];
                case 1:
                    fbxObject = _g.sent();
                    // Wait for everything to be loaded
                    return [4 /*yield*/, new Promise(function (r) { return (manager.onLoad = function () { return r(); }); })];
                case 2:
                    // Wait for everything to be loaded
                    _g.sent();
                    scene = new realms_three_1.default.Scene();
                    camera = new realms_three_1.default.PerspectiveCamera(fov, imgWidth / imgHeight, 5, 20000);
                    // Add to scene
                    scene.add(fbxObject);
                    _b = (0, camera_utils_1.getCameraPositionToSeeObject)([fbxObject], camera), cameraPosition = _b.cameraPosition, cameraLookPosition = _b.cameraLookPosition;
                    // Set camera position
                    camera.position.setX(cameraPosition.x);
                    camera.position.setY(cameraPosition.y);
                    camera.position.setZ(cameraPosition.z);
                    camera.lookAt(new realms_three_1.default.Vector3(cameraLookPosition.x, cameraLookPosition.y, cameraLookPosition.z));
                    scene.add(new realms_three_1.default.AmbientLight(0x444444, 5));
                    directionalLight = new realms_three_1.default.DirectionalLight(0xffffff);
                    directionalLight.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z);
                    scene.add(directionalLight);
                    light = new realms_three_1.default.HemisphereLight(0xffffff, 0xaaaaaa, 1);
                    light.position.set(cameraPosition.x, cameraPosition.y, cameraPosition.z);
                    scene.add(light);
                    return [2 /*return*/, (0, sceneUtils_1.sceneToDataUrl)({
                            scene: scene,
                            camera: camera,
                            width: imgWidth,
                            height: imgHeight,
                            alpha: true,
                            beforeRender: function (props) {
                                props.renderer.setClearColor(0x000000, 0);
                            },
                        })];
            }
        });
    });
}
exports.fbxToImg = fbxToImg;
